import "./LoadingSpinner.css";

export const LoadingSpinner = () => {
	return (
		<div className='container m-5 mx-auto d-flex justify-content-center'>
			<div className="lds-roller">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	);
};
